import { inboxLabelDisplayText, KnownInboxLabel } from "@qw/qw-common";
import type { MaterialSymbol } from "@qw/ui";
import isEqual from "lodash/isEqual";

export interface LabelMenuItem {
  labels: string[];
  icon: MaterialSymbol;
  text: string;
  search: string;
}

export const labelMenuItems: Record<string, LabelMenuItem> = {
  [KnownInboxLabel.INBOX]: {
    labels: [KnownInboxLabel.INBOX],
    icon: "inbox",
    text: "Inbox",
    search: "",
  },
  [KnownInboxLabel.STARRED]: {
    labels: [KnownInboxLabel.STARRED],
    icon: "star",
    text: "Starred",
    search: `?labels=${KnownInboxLabel.STARRED}`,
  },
  [KnownInboxLabel.UNREAD]: {
    labels: [KnownInboxLabel.UNREAD],
    icon: "mark_email_unread",
    text: "Unread",
    search: `?labels=${KnownInboxLabel.UNREAD}`,
  },
  [KnownInboxLabel.SENT]: {
    labels: [KnownInboxLabel.SENT],
    icon: "send",
    text: "Sent",
    search: `?labels=${KnownInboxLabel.SENT}`,
  },
  [KnownInboxLabel.TRASH]: {
    labels: [KnownInboxLabel.TRASH],
    icon: "delete",
    text: "Trash",
    search: `?labels=${KnownInboxLabel.TRASH}`,
  },
  [KnownInboxLabel.SPAM]: {
    labels: [KnownInboxLabel.SPAM],
    icon: "report",
    text: "Spam",
    search: `?labels=${KnownInboxLabel.SPAM}`,
  },
  [KnownInboxLabel.QW_AI_SUBMISSION]: {
    labels: [KnownInboxLabel.QW_AI_SUBMISSION],
    icon: "campaign",
    text: inboxLabelDisplayText[KnownInboxLabel.QW_AI_SUBMISSION],
    search: `?labels=${KnownInboxLabel.QW_AI_SUBMISSION}`,
  },
  [KnownInboxLabel.QW_AI_QUOTE]: {
    labels: [KnownInboxLabel.QW_AI_QUOTE],
    icon: "request_quote",
    text: inboxLabelDisplayText[KnownInboxLabel.QW_AI_QUOTE],
    search: `?labels=${KnownInboxLabel.QW_AI_QUOTE}`,
  },
  [KnownInboxLabel.QW_AI_FORWARDED]: {
    labels: [KnownInboxLabel.QW_AI_FORWARDED],
    icon: "forward",
    text: inboxLabelDisplayText[KnownInboxLabel.QW_AI_FORWARDED],
    search: `?labels=${KnownInboxLabel.QW_AI_FORWARDED}`,
  },
  [KnownInboxLabel.QW_AI_PROCESSING]: {
    labels: [KnownInboxLabel.QW_AI_PROCESSING],
    icon: "hourglass",
    text: "Processing",
    search: `?labels=${KnownInboxLabel.QW_AI_PROCESSING}`,
  },
  [KnownInboxLabel.ALL_MAIL]: {
    labels: [],
    icon: "inventory_2",
    text: "All Mail",
    // IMPORTANT: We need to use an actual value for the label here so nuqs recognizes
    // it as distinct and will trigger a re-render. We convert back to an empty
    // array in the `InboxQueryStatesProvider`.
    search: `?labels=${KnownInboxLabel.ALL_MAIL}`,
  },
};

export const matchLabelMenuItem = (labels: string[]): LabelMenuItem =>
  Object.values(labelMenuItems).find((menuItem) => isEqual(menuItem.labels, labels)) || {
    labels,
    icon: "label" as MaterialSymbol,
    text: labels.join(", "),
    search: `?labels=${labels.join(",")}`,
  };
